import React from 'react';
import { Icon, Tooltip, P } from 'design-system-web';
import { SupportedLocaleEnum } from 'localization';
import { useTranslation } from 'react-i18next';
import {
  type SupportedPaymentCurrency,
  formatCurrency,
} from 'domains-billing-currency';
import cx from 'classnames';
import styles from './RateChangeIndicator.scss';

type Props = {
  originalRate: number;
  currentRate: number;
  currency: SupportedPaymentCurrency;
  locale: SupportedLocaleEnum;
  className?: string;
  testId?: string;
};

const ARROW = ' → ';

export function RateChangeIndicator({
  originalRate,
  currentRate,
  currency,
  locale,
  className,
  testId,
}: Props) {
  const { t } = useTranslation();

  const currencyFormat = formatCurrency(currency, {
    locale,
  });

  const tooltipComponent = () => {
    return (
      <div className={styles.rateChangeToolTip}>
        <P className={styles.textColor}>
          {t('abp.charges.rateChange.label')}{' '}
          <span className={styles.strike}>{currencyFormat(originalRate)}</span>
          {ARROW}
          {currencyFormat(currentRate)}
        </P>
      </div>
    );
  };

  return (
    <div
      className={cx(styles.rateChangeIndicator, className)}
      data-test={testId}
    >
      <Tooltip
        TooltipComponent={tooltipComponent()}
        zIndex={100}
        placement="left"
        wrapperClassName={styles.container}
      >
        <Icon
          name="exclamation-circle"
          set="FontAwesome"
          type="far"
          size="medium"
        />
      </Tooltip>
    </div>
  );
}
